import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useMainSliderStore = defineStore('mainSlider', {
    state() {
        return {
            allSlides: [],
        }
    },
    actions: {
        async getAllSlides() {
            this.allSlides = await helper.api('GET', '/main_slider', {})
        },
    },
    getters: {
        getSlides(state) {
            return state.allSlides
        },
    }
})
